export default {

  setBills(state, data) {
    state.bills = data;
  },

  setParts(state, data) {
    state.parts = data;
  },

  setLoans(state, data) {
    state.loans = data;
  },

  setRewards(state, data) {
    state.rewards = data;
  },

};
